module.exports = __webpack_public_path__ + "static/media/texticon.04571da3.svg";